export const formatDate = (dateString) => {
    try {
      return new Intl.DateTimeFormat(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
        timeZoneName: 'short'
      }).format(new Date(dateString));
    } catch (err) {
      console.error('Date formatting error:', err);
      return '—';
    }
  };